// extracted by mini-css-extract-plugin
export var productImage = "_nh-1";
export var viewLink = "_nh-2";
export var wishlistItem = "_nh-0";